import React from 'react';
import styled from 'styled-components';

import * as S from './RoomSelection.styles';

import {
  Column as FlexColumn,
  Row,
} from '../../../../../stories/components/hotels/common/Layouts/Layouts';

import ViewMoreDetails from '../../../../../stories/components/hotels/DetailsPage/ViewRoomDetails/ViewRoomDetails'
import Modal from '../../../../components/Modal';
import RoomFlavors from './RoomFlavors';

import {RplType, EmiDataType} from '../../redux/types';

import useCarousel from '../../../../hooks/useCarousel';
import {useModal} from '../../../../components/Modal';

const Column = styled(FlexColumn)(
  props => `

    width: 100%;
    border-bottom: 0.8rem solid ${props.theme.colors.grey.grey15};
    &:last-child {
      border-bottom: none;
    }
`,
);

export type RoomTypeColumnProps = {
  maxNoOfAdults?: number;
  roomSize?: string;
  bedType?: string;
  imageUrl?: string;
  roomTypeName?: string;
  extraBedType?: string;
  roomDescription?: string;
  roomFacilities?: string[];
  roomImages?: string[];
  noInclusionsAndSplInstructionsForAnyRoom: boolean;
};

const RoomTypeColumn: React.FC<RoomTypeColumnProps> = ({
  maxNoOfAdults,
  roomSize,
  bedType,
  imageUrl,
  roomTypeName,
  extraBedType,
  roomDescription,
  roomFacilities = [],
  roomImages = [],
}) => {
  // const persuasionText = "This persuasion text hasn't been integrated yet";

  const {isModalOpen, closeModal, openModal} = useModal();

  /**
   * 🐨 use carousel can be heavily improved improve it
   */
  const {
    increment,
    decrement,
    leftCursor,
    rightCursor,
    isLeftCursorActive,
    isRightCursorActive,
  } = useCarousel(roomImages, 1);

  return (
    <>
      <S.RoomTypeWrap>
        <S.RoomTypeInnerWrap>
          <S.RoomTypeImgWrap>
            {imageUrl && (
              <>
                <a
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    openModal();
                  }}
                >
                  <S.RoomTypeImg
                    src={imageUrl}
                  />
                </a>
                <S.BottomTextWrap>
                  <S.BottomText>{roomTypeName}</S.BottomText>
                </S.BottomTextWrap>
              </>
            )}
            {/* <S.FewAvailRoomTag>
              <S.AvailRoomTagText>Few Rooms Left</S.AvailRoomTagText>
            </S.FewAvailRoomTag>
            <S.LeftIconWrap>
                <WhiteArrowLeft width="4rem" height="4rem"/>
            </S.LeftIconWrap>
            <S.RightIconWrap>
                <WhiteArrowRight width="4rem" height="4rem"/>
            </S.RightIconWrap> */}
          </S.RoomTypeImgWrap>

          {roomTypeName && <S.RoomTypeNameText>{roomTypeName}</S.RoomTypeNameText>}

          <S.RoomInfoOuterWrap>
            {!!roomSize && (
              <S.RoomInfoInnerWrap>
                <S.RoomInfoHeadText>Room Size: {roomSize}</S.RoomInfoHeadText>
                {/* <S.RoomInfoSubText>Larger than most rooms!</S.RoomInfoSubText> */}
              </S.RoomInfoInnerWrap>
            )}
            {!!maxNoOfAdults && (
              <S.RoomInfoInnerWrap>
                <S.RoomInfoHeadText>Max Capacity: {maxNoOfAdults} Adults</S.RoomInfoHeadText>
                <S.RoomInfoSubText>Kids below 2yrs stay free!</S.RoomInfoSubText>
              </S.RoomInfoInnerWrap>
            )}
          </S.RoomInfoOuterWrap>

          <S.RoomInfoOuterWrap>
            {!!bedType && (
              <S.RoomInfoInnerWrap>
                <S.RoomInfoHeadText>{bedType} sized bed</S.RoomInfoHeadText>
              </S.RoomInfoInnerWrap>
            )}
            {!!extraBedType && (
              <S.RoomInfoInnerWrap>
                <S.RoomInfoHeadText>Extra {extraBedType} available</S.RoomInfoHeadText>
              </S.RoomInfoInnerWrap>
            )}
          </S.RoomInfoOuterWrap>

          {(!!roomFacilities.length || !!roomDescription || !!roomImages.length) && (
            <S.RoomInfoOuterWrap onClick={() => {
              openModal();
            }}>
              <S.RoomInfoInnerWrap>
                  <S.RoomInfoMoreText>More room amenities</S.RoomInfoMoreText>
              </S.RoomInfoInnerWrap>
            </S.RoomInfoOuterWrap>
          )}
        </S.RoomTypeInnerWrap>
      </S.RoomTypeWrap>

      <Modal
        isOpen={isModalOpen}
        closeModal={closeModal}
        modalStyles={{
          height: '90vh',
          width: 'auto',
        }}
        CloseButton={() => null}
      >
        <ViewMoreDetails
          roomDescription={roomDescription}
          roomFacilities={roomFacilities}
          roomTypeName={roomTypeName}
          roomImages={roomImages}
          closeModal={closeModal}
          onRightArrowClick={increment}
          onLeftArrowClick={decrement}
          showLeftArrow={isLeftCursorActive}
          showRightArrow={isRightCursorActive}
          leftCursor={leftCursor}
          rightCursor={rightCursor}
        />
      </Modal>
    </>
  );
};

export interface RoomFlavorProps {
  roomFlavorName: string;
  refundStatusText: string;
  refundStatusTextColor: string;
  amenities: string[];
  exclusions: string[];
  // cancellationData: RplType['fcp'];
  uid: string;
  isRecommended: boolean;
  slashedPrice: number;
  showPrice: number;
  emiData: {
    emiStartingPrice: EmiDataType['emi'];
    emiRates: EmiDataType['emiRates'];
  };
  forwardParams: {
    prgen: string;
    vhid: string;
    ps: string; // format – "6000|4494|539"
    ts: string; // "2020-01-07T12:10:38"
    hctx: string;
    hctxty: string;
    srctx: string;
  };
  roomPriceCode: string;
  offercode: string;
  vendor: string;
  paymode: number;
  roomTypeCode: string;

  gseg: RplType['gseg'];
  cot: RplType['cot'];
  hmd: RplType['hmd'];
  gsv: RplType['gsv'];
  pc: RplType['pc'];
  paxString: string;
  gtv: string;
}

type RoomProps = {
  roomTypeColumnProps: RoomTypeColumnProps;
  roomFlavorsList: RoomFlavorProps[];
  noInclusionsAndSplInstructionsForAnyRoom: boolean;
};
// | RoomFlavorsPropTypes;

const Room: React.FC<RoomProps> = props => {
  const {roomTypeName = ''} = props.roomTypeColumnProps;

  return (
    <S.RoomDetailRoomType>
      <RoomTypeColumn {...props.roomTypeColumnProps} />

      <RoomFlavors
        roomFlavorsList={props.roomFlavorsList}
        roomTypeName={roomTypeName}
        noInclusionsAndSplInstructionsForAnyRoom={props.noInclusionsAndSplInstructionsForAnyRoom}
      />
      {/* <RoomFlavors /> */}
    </S.RoomDetailRoomType>
  );
};

export default Room;
